import { render, staticRenderFns } from "./Hold.vue?vue&type=template&id=bed5aa04&"
import script from "./Hold.vue?vue&type=script&lang=js&"
export * from "./Hold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports